import { useFormik } from 'formik'
import { Button, FormInput, FormSelect, IOption } from '../../../../../components'
import { PrescricaoDtoUtilizacao } from '../../../../apps/atendimento_medicos/prescricao/core/_model'
import {
  ButtonType,
  IconPaths,
  IconSize,
  MaskType,
  OptionsHelper,
  showAlert,
  showError,
} from '../../../../../../_metronic/helpers'
import { FC } from 'react'
import { usePrescricaoSchema } from './validation/usePrescricaoSchema'
import { registerUseOfPrescricao } from '../../core/_request'

type IUsePrescricaoModal = {
  tokenPrescricao: string
  tokenPaciente: string
  /** Chamado após a dispensação ser registrada com sucesso (ex.: voltar à etapa inicial). */
  onSuccess?: () => void
}

export const UsePrescricaoModal: FC<IUsePrescricaoModal> = ({
  tokenPrescricao,
  tokenPaciente,
  onSuccess,
}) => {
  const initialValues: {
    token: string
    codigo: string
    nome: string
    nomeFarmacia: string
    cpf: string
    crf: string
    uf: IOption<string> | undefined
  } = {
    token: tokenPrescricao || '',
    codigo: tokenPaciente || '',
    nome: '',
    nomeFarmacia: '',
    cpf: '',
    crf: '',
    uf: undefined,
  }

  const formik = useFormik({
    initialValues,
    validationSchema: usePrescricaoSchema,
    onSubmit: async (values, { resetForm }) => {
      const data: PrescricaoDtoUtilizacao = { ...values, uf: values.uf?.value as string }
      try {
        await registerUseOfPrescricao(data)
        await showAlert({ title: 'Sucesso!', text: 'A receita foi dispensada.', icon: 'success' })
        resetForm()
        onSuccess?.()
      } catch (error) {
        showError(error)
      }
    },
  })
  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      {!tokenPrescricao && (
        <FormInput
          formik={formik}
          label='Token de acesso'
          placeholder='Digite o token de acesso'
          name='token'
          className='mb-8'
          isRequired
          infoText='Token presente na prescrição'
        />
      )}
      {!tokenPaciente && (
        <FormInput
          formik={formik}
          label='Código de desbloqueio'
          placeholder='Digite o código de desbloqueio'
          name='codigo'
          className='mb-8'
          infoText='Código presente na prescrição'
          isRequired
        />
      )}
      <FormInput
        formik={formik}
        name='nome'
        placeholder='Digite seu nome'
        label='Nome'
        className='mb-3'
        isRequired
      />
      <FormInput
        formik={formik}
        name='cpf'
        placeholder='Digite seu CPF'
        label='CPF'
        mask={MaskType.CPF}
        className='mb-3'
        isRequired
      />
      <FormInput
        formik={formik}
        name='crf'
        placeholder='Digite seu CRF'
        label='CRF'
        className='mb-3'
        isRequired
      />
      <FormSelect
        formik={formik}
        name='uf'
        placeholder='Selecione seu estado'
        label='Estado'
        fetchOptions={OptionsHelper.getOptionsEstadosUfPublic}
        isClearable={false}
        className='mb-3'
        isRequired
      />
      <FormInput
        formik={formik}
        name='nomeFarmacia'
        placeholder='Digite o nome da farmácia'
        label='Farmácia'
        className='mb-3'
        isRequired
      />
      <Button
        type={ButtonType.Submit}
        className='btn-primary btn-auth-full mt-5'
        icon={IconPaths.Check}
        iconSize={IconSize.Small}
      >
        Dispensar receita
      </Button>
    </form>
  )
}
